import gql from 'graphql-tag'

export default gql`mutation editSchedule($data: UserScheduleInput!){
    editSchedule(data: $data) @client
}`